export default __webpack_public_path__ + "static/media/12.5d51dba4.png";